export default __webpack_public_path__ + "static/media/360.40a17b7b.svg";